__turbopack_context__.v({
  "className": "montserrat_258c1014-module__ZKY0pq__className",
  "variable": "montserrat_258c1014-module__ZKY0pq__variable",
});
